import styled from 'styled-components'

export const ErrorWrapper = styled.div`
    color: #ff6666;
`

export const Input = styled.input`
	width: 100%;
	height: 48px;
	outline: none;
	border: 1px solid
		${(props) =>
		(props.status === 'valid' && props.theme.mainGreen) ||
		(props.status === 'error' && props.theme.mainRed) ||
		props.theme.inputBorder};
	background-color: ${(props) => props.theme.input} !important;
	color: ${(props) => props.theme.inputPlaceHolder};
	border-radius: 8px;
	/* margin-top: 5px; */
	font-size: 0.9rem;
	/* letter-spacing: 1.5px; */
	font-weight: 500;
	padding: 10px 20px;
	direction: rtl;
	&:focus {
		border-color:${(props) =>
		(props.status === 'valid' && props.theme.mainGreen) ||
		(props.status === 'error' && props.theme.mainRed) ||
		props.theme.main};
	}
	@media screen and (max-width: 768px) {
		height: 42px;
	}
`

export const SubmitBtn = styled.button`
	margin-top: 25px;
	width: 100%;
	height: 42px;
	border-radius: 8px;
	color: #FFFFFF !important;
	background-color: ${(props) => props.theme.main};
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: 0 0 4px ${(props) => props.theme.primaryBg};
	font-weight: 500;
	cursor: ${(props) => (props.active && 'pointer') || 'not-allowed'};
	pointer-events: ${(props) => (props.active ? 'auto' : 'none')};
	&:hover {
		background-color: ${(props) => props.active && '#1099f995'};
	}

	@media screen and (max-width: 768px) {
		width: 100%;
		margin-top: 15px;

	}

`

export const Body = styled.div`
	position: relative;
	background-color: ${(props) => props.theme.secondaryBg};
	min-width: 500px;
	padding: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 8px;
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
	transition: all 0.3s 0.3s;

	@media screen and (max-width: 768px) {
		min-width: 90%;
	}
`

export const Title = styled.div`
	color: ${(props) => props.theme.secondary};
	font-size: 1rem;
	font-weight: 600;
	/* letter-spacing: 1.3px; */

	@media screen and (max-width: 480px) {
		font-size: 0.8rem;
	}
`

export const Row = styled.div`
	width: 80%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-top: ${(props) => props.marginTop || '16px'};
	position: relative;
	transition: all 0.3s;
	@media screen and (max-width: 768px) {
		width: 100%;
	}
`

export const RulesContainer = styled.div`
	width: 80%;
	margin-top: 20px;
	display: flex;
	align-items: center;
	color: ${(props) => props.theme.color};

	@media screen and (max-width: 768px) {
		width: 100%;
		margin-top: 15px;
		font-size: 0.5rem;
	}
`

export const Rules = styled.span`
	color: ${(props) => props.theme.mainOrange};
	font-size: ${(props) => props.fontSize || '0.9rem'};
	cursor: pointer;
`

export const CheckBox = styled.div`
	width: 24px;
	height: 24px;
	margin: 0 6px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 6px;
	cursor: pointer;
	color: black;
	background-color: ${(props) => props.theme.checkbox};
	border: 1px solid;
	border-color: ${(props) => props.theme.main};
	/* box-shadow: 0 0 2px black; */

	@media screen and (max-width: 768px) {
		width: 18px;
		height: 18px;
	}

	&:hover{
	box-shadow: 0 0 2px 2px rgba(0,0,0,0.2);

	}

`

export const Label = styled.div`
	font-size: 0.8rem;
	color: ${(props) => props.theme.textColor};
	margin: 0 10px;
	white-space: nowrap;	
	margin-bottom: 5px;
`

export const TabChanger = styled.div`
	//position: absolute;
	bottom: 15px;
	display: flex;
	align-items: center;
	font-size: 0.9rem;
	// color: ${(props) => props.theme.color};

	@media screen and (max-width: 480px) {
		font-size: 0.8rem;
	}
`